// extracted by mini-css-extract-plugin
export default {"button":"MultiRev_button__22S5O","internal":"MultiRev_internal__pimcY","buttonDark":"MultiRev_buttonDark__5VYWW"};